import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';

@Component({
  selector: 'app-promocion-grupo-cliente',
  templateUrl: './promocion-grupo-cliente.component.html',
  styleUrls: ['./promocion-grupo-cliente.component.css']
})
export class PromocionGrupoClienteComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsCondGrupoCliente = [];
  frameworkComponents: any;
  rowDataCondGrupoCliente: any[] = [];
  verFormularioAgregarCondGrupoCliente = false;

  idPromo: string;
  desc: string = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarCondGrupoCliente(id);
      }
    });
    this.route.queryParams.subscribe((query) => {
      this.desc = query['desc'];
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsCondGrupoCliente = [
      {
        headerName: 'Grupo Cliente',
        field: 'id_grupo_cliente',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Descripción',
        field: 'dsca_grupo_cliente',
        sortable: true,
        filter: true
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminarCondGrupoCliente.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block',
        },
      },
    ];
  }

  nuevoCondGrupoCliente() {
    this.verFormularioAgregarCondGrupoCliente = true;
  }

  back() {
    this.verFormularioAgregarCondGrupoCliente = false;
  }

  cargarCondGrupoCliente(id_promo) {
    this.promocionesService.cargarCondGrupoCliente(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataCondGrupoCliente = resp;
        } else {
          this.rowDataCondGrupoCliente = [];
        }
      },
      (error) => {
        this.rowDataCondGrupoCliente = [];
      }
    );
  }

  eliminarCondGrupoCliente({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        action: 'Eliminar',
        funcion: this.promocionesService.borrarCondGrupoCliente(rowData),
      })
      .then((res: any) => {
        this.cargarCondGrupoCliente(this.idPromo);
      });
  }

  guardarCondGrupoCliente(payload: any) {
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: 'Nuevo',
        funcion: this.promocionesService.crearCondGrupoCliente(payload),
      })
      .then((res: any) => {
        this.cargarCondGrupoCliente(this.idPromo);
        this.verFormularioAgregarCondGrupoCliente = false;
      });
  }

  eliminarTodo() {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.condGrupoClienteDeleteAll(this.idPromo),
      })
      .then((res: any) => {
        this.cargarCondGrupoCliente(this.idPromo);
      });
  }

}
